@if (isErrorGetResources) {
  <div id="ExchangeItems" class="page-layout blank" class="page-layout simple" fxLayout="column">
    <!-- HEADER -->
    <div class="header">
        <div class="name field" [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
            {{'RESOURCE-MANAGEMENT.TITLE' | translate }}
        </div>
    </div>
    <!-- / HEADER -->
    <div class="content-card" fxFill>
      <div class="message-box error user-created">
        <app-error-message [error]="errorGetResources.error" />
      </div>
    </div>
  </div>
}@else{
  <!-- HEADER -->
  <div class="header">
      <div class="name field" [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
          {{'RESOURCE-MANAGEMENT.TITLE' | translate }}
      </div>
  </div>
    <!-- / HEADER -->
  <app-exchange-page 
  exchangeType="resource" 
  url="/exchange/resource" 
  [displayedColumns]="displayedColumns"  
  [hiddenColumns]="hiddenColumns"
  [dataSource]="dataSource"
  [addDialogComponent]="ResourceAddDialogComponent"
  [deleteDialogComponent]="ResourceDeleteConfirmComponent"
  [isLoading]="isLoading"
  [hasNoExchangeItems]="hasNoRessources"
  (refreshList)="getListOfRessources()"
  />
}